export enum HomeMileageRouteCase {
  REGISTRATION_GUIDE_2026, // = "2026 신규 가입 안내",
  PERFORMANCE_REGISTRATION_REQUIRED, // = "실적 등록필요",
  PENDING_APPROVAL, // = "승인 대기중",
  MILEAGE_ACCESS_ALLOWED, // = "접근 허용"
}

export function getHomeMileageRouteCase({
  confmSttCd,
  drvngRgsYn,
  seasonRgsyn,
}: {
  confmSttCd: string;
  drvngRgsYn: string;
  seasonRgsyn: string;
}) {
  if (drvngRgsYn === '03') {
    return HomeMileageRouteCase.REGISTRATION_GUIDE_2026;
  }
  if (confmSttCd === '01') {
    return HomeMileageRouteCase.PENDING_APPROVAL;
  }
  if (drvngRgsYn === '02' && seasonRgsyn === '03') {
    return HomeMileageRouteCase.MILEAGE_ACCESS_ALLOWED;
  }
  return HomeMileageRouteCase.PERFORMANCE_REGISTRATION_REQUIRED;
}
